/**
 * A string template used to format payment details, including the payment type and expiration date.
 *
 * The placeholders in the template are:
 * - `%s` (1st): The expiration month in two-digit format (e.g., "12").
 * - `%s` (2nd): The expiration year in two-digit format (e.g., "25").
 */
export const APPLE_PAY_DETAILS_FORMAT = 'Expires %s / %s';

/**
 * A tooltip message for the expiration date of the Apple Pay wallet.
 */
export const APPLE_PAY_EXPIRATION_TOOLTIP = 'Your Wallet expiration date';
